import GeneralView from './GeneralView';
export default { GeneralView };
